import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { getCaption } from '@alfa-bank/site-helpers-form/meta/get-caption';
import { isSuccess } from '@alfa-bank/site-helpers-form/meta/is-success';
import { isError } from '@alfa-bank/site-helpers-form/meta/is-error';
import { Field } from '@alfa-bank/site-form-utils/components/form-field';
import { Input } from '@alfa-bank/site-input';
import { Caption } from '@alfa-bank/site-caption';
import { Link } from '@alfa-bank/site-link';

import type { TPromoCode, IDeps } from './models';
import { PromoCode as Component } from './promo-code';
import { validatePromoCode, formatPromoCode } from './helpers';
import styles from './styles.css';

export const PromoCode = createWidget<IDeps, TPromoCode>({
    Caption,
    Field,
    Input,
    Link,
    formatPromoCode,
    getCaption,
    isError,
    isSuccess,
    validatePromoCode,
    styles,
})(Component);
